import { DividerProps } from "./types"
import { StyledDivider } from './styles';

export const Divider = ({spacing}: DividerProps) => {
    return <StyledDivider spacing={spacing}/>
}